import Vue from 'vue'
import Router from 'vue-router'
import process from "shelljs";

/* 主路由 */
const Evaluation = resolve => require.ensure([], () => resolve(require('@/views/Evaluation')), 'Evaluation');
const MyEvaluation = resolve => require.ensure([], () => resolve(require('@/views/Evaluation/my_evaluation')), 'MyEvaluation');
const WxDoctorEvaluate = resolve => require.ensure([], () => resolve(require('@/views/wxDoctorEvaluate/index.vue')), 'WxDoctorEvaluate');
const QRcode = resolve => require.ensure([], () => resolve(require('@/views/outpatient/QRcode')), 'QRcode');
const Not = resolve => require.ensure([], () => resolve(require('@/views/Not')), 'Not');
const Main = resolve => require.ensure([], () => resolve(require('@/views/Main')), 'Main');
/* 空页面 */
const Blank = resolve => require.ensure([], () => resolve(require('@/views/Blank')), 'Blank');
/* 我的 */
const Account = resolve => require.ensure([], () => resolve(require('@/views/account/Mine.vue')), 'Account');
// 帮助中心
const HelpCenter = resolve => require.ensure([], () => resolve(require('../views/account/help-center/HelpCenter.vue')), 'HelpCenter');
//就医指南
const MedicalGuide = resolve => require.ensure([], () => resolve(require('@/views/guide/MedicalGuide.vue')), 'MedicalGuide');
const MedicalGuideContent = resolve => require.ensure([], () => resolve(require('@/views/guide/MedicalGuideContent.vue')), 'MedicalGuideContent');
/* 健康卡列表 */
const HealthCardList = resolve => require.ensure([], () => resolve(require('@/views/account/health-card/HealthCardList')), 'HealthCardList');
/* 健康卡信息填写注册 */
const CardInformation = resolve => require.ensure([], () => resolve(require('@/views/account/health-card/CardInformation')), 'CardInformation');
/* 健康卡信息注册成功前往人脸识别 */
const FaceRecognition = resolve => require.ensure([], () => resolve(require('@/views/account/health-card/FaceRecognition')), 'FaceRecognition');
/* 健康卡详细信息 */
const CardDetail = resolve => require.ensure([], () => resolve(require('@/views/account/health-card/CardDetail.vue')), 'CardDetail');
/* 健康卡绑定亲属关系 */
const Relationship = resolve => require.ensure([], () => resolve(require('@/views/account/health-card/Relationship')), 'Relationship');
/* 医院信息 */
const HospitalInformation = resolve => require.ensure([], () => resolve(require('@/views/hospitalInfo')), 'HospitalInformation');
/*科室列表导航 */
const DepartmentList = resolve => require.ensure([], () => resolve(require('@/views/department/DepartmentList')), 'DepartmentList');
const DepartmentIndex = resolve => require.ensure([], () => resolve(require('@/views/department/DepartmentIndex')), 'DepartmentIndex');
const DepartmentNavigation = resolve => require.ensure([], () => resolve(require('@/views/department/DepartmentNavigation')), 'DepartmentNavigation');
/*科室医生信息 */
const DoctorsList = resolve => require.ensure([], () => resolve(require('@/views/department/DoctorsList')), 'DoctorsList');
const DoctorProfile = resolve => require.ensure([], () => resolve(require('@/views/department/DoctorProfile')), 'DoctorProfile');
/* 预约挂号科室列表  */
const AppointmentDepartmentList = resolve => require.ensure([], () => resolve(require('@/views/department/AppointmentDepartmentList.vue')), 'AppointmentDepartmentList');
const NumSourceList = resolve => require.ensure([], () => resolve(require('@/views/NumSource/NumSourceList.vue')), 'NumSourceList');
const ConfirmationAppointment = resolve => require.ensure([], () => resolve(require('@/views/appointment/ConfirmationAppointment.vue')), 'ConfirmationAppointment');
//医生时段号源
const DoctorTimePeriodNumSource = resolve => require.ensure([], () => resolve(require('@/views/NumSource/DoctorTimePeriodNumSource.vue')), 'DoctorTimePeriodNumSource');
const Success = resolve => require.ensure([], () => resolve(require('@/views/PayResult/Success.vue')), 'Success');
/*当日挂号科室列表*/
const TodayDepartmentList = resolve => require.ensure([], () => resolve(require('@/views/department/TodayDepartmentList.vue')), 'TodayDepartmentList');
const TodayNumSourceList = resolve => require.ensure([], () => resolve(require('@/views/NumSource/TodayNumSourceList.vue')), 'TodayNumSourceList');
/* 门诊处方 */
const OutpatientPrescription = resolve => require.ensure([], () => resolve(require('@/views/outpatient/OutpatientPrescription')), 'OutpatientPrescription');
const OutpatientDetails = resolve => require.ensure([], () => resolve(require('@/views/outpatient/OutpatientDetails')), 'OutpatientDetails');
const OutpatientUnpaidDetails = resolve => require.ensure([], () => resolve(require('@/views/outpatient/OutpatientUnpaidDetails.vue')), 'OutpatientUnpaidDetails');
/* 住院预缴费 */
const HospitalizationInput = resolve => require.ensure([], () => resolve(require('@/views/hospitalization/HospitalizationInput')), 'HospitalizationInput');
const HospitalizationDetails = resolve => require.ensure([], () => resolve(require('@/views/hospitalization/HospitalizationDetails')), 'HospitalizationDetails');
const HospitalizationPayment = resolve => require.ensure([], () => resolve(require('@/views/hospitalization/HospitalizationPayment')), 'HospitalizationPayment');
const HospitalizationMoney = resolve => require.ensure([], () => resolve(require('@/views/hospitalization/HospitalizationMoney')), 'HospitalizationMoney');
const HospitalizationDailyListingList = resolve => require.ensure([], () => resolve(require('@/views/hospitalization/HospitalizationDailyListingList')), 'HospitalizationDailyListingList');
/* 挂号记录*/
const Register = resolve => require.ensure([], () => resolve(require('@/views/appointment/record/Register')), 'Register');
const RegisterContent = resolve => require.ensure([], () => resolve(require('@/views/appointment/record/RegisterContent')), 'RegisterContent');
// 核酸检测预约须知
const Booking = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/nat/BookingInformation.vue')), 'Booking');
// 检测核酸检测问诊表是否填写
const Interrogationfinish = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/nat/Finish.vue')), 'Interrogationfinish');
// 核酸检测
const Nat = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/nat/Nat.vue')), 'Nat');
// 核酸检测流行病学史参考问诊
const Interrogationtable = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/nat/Interrogationtable.vue')), 'Interrogationtable');
// 核酸预约记录
const Natrecord = resolve => require.ensure([], () => resolve(require('@/views/nat-record/NatRecord.vue')), 'Natrecord');
// 核酸预约记录
const NatrecordDetails = resolve => require.ensure([], () => resolve(require('@/views/nat-record/NatRecordDetails.vue')), 'NatrecordDetails');
// 报告查询
const Report = resolve => require.ensure([], () => resolve(require('@/views/report/Report.vue')), 'Report');
// 检验报告
const Checkout = resolve => require.ensure([], () => resolve(require('@/views/report/Checkout.vue')), 'Checkout');
// 检查报告
const Inspect = resolve => require.ensure([], () => resolve(require('@/views/report/Inspect.vue')), 'Inspect');
// 健康宣教
const HealthEducation = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/health_education/HealthEducation.vue')), 'HealthEducation');
// 慢病栏目
const ArticleList = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/health_education/ArticleList.vue')), 'ArticleList');
// 心理栏目
const Psychology = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/health_education/Psychology.vue')), 'Psychology');
// 就医栏目
const Hospitalize = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/health_education/Hospitalize.vue')), 'Hospitalize');
// 慢病栏目详情页
const ArticleDetail = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/health_education/ArticleDetail.vue')), 'ArticleDetail');
// 心理栏目详情页
const Psychologycontent = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/health_education/Psychologycontent.vue')), 'Psychologycontent');
// 就医栏目
const Hospitalizecontent = resolve => require.ensure([], () => resolve(require('@/views/PersonalCenter/health_education/Hospitalizecontent.vue')), 'Hospitalizecontent');
//院内导航
const Hospitalnavigation = resolve => require.ensure([], () => resolve(require('../views/hospitalnavigation/index.vue')), 'hospitalnavigation');

//消息中心
const MessageCenter = resolve => require.ensure([], () => resolve(require('@/views/message/MessageCenter')), 'MessageCenter');
const MessageDetail = resolve => require.ensure([], () => resolve(require('@/views/message/MessageDetail.vue')), 'MessageDetail');
//中药
const zyNotice = resolve => require.ensure([], () => resolve(require('@/views/medicine/zyNotice')), 'zyNotice');
const MedicineBuy = resolve => require.ensure([], () => resolve(require('@/views/medicine/MedicineBuy')), 'MedicineBuy');
const OnlinePrescription = resolve => require.ensure([], () => resolve(require('@/views/Prescription/OnlinePrescription')), 'OnlinePrescription');
const OnlinePrescriptionDetails = resolve => require.ensure([], () => resolve(require('@/views/Prescription/OnlinePrescriptionDetails')), 'OnlinePrescriptionDetails');
const OnlinePrescriptionDetails_wzf = resolve => require.ensure([], () => resolve(require('@/views/Prescription/OnlinePrescriptionDetails_wzf')), 'OnlinePrescriptionDetails_wzf');
const ScanToPay = resolve => require.ensure([], () => resolve(require('@/views/outpatient/ScanToPay')), 'ScanToPay');
const Prescription = resolve => require.ensure([], () => resolve(require('@/views/Prescription')), 'Prescription');
//医保入口
const HealthCare = resolve => require.ensure([], () => resolve(require('@/views/home/HealthCare.vue')), 'HealthCare');
const HomeNeirong = resolve => require.ensure([], () => resolve(require('@/views/home/HomeNeirong')), 'HomeNeirong');
const Homepage = resolve => require.ensure([], () => resolve(require('@/views/home/Homepage.vue')), 'Homepage');

//智慧导诊
const WisdomLeading = resolve => require.ensure([], () => resolve(require('@/views/WisdomLeading')), 'WisdomLeading');
//支付结果
const PayResult = resolve => require.ensure([], () => resolve(require('@/views/PayResult')), 'PayResult');
//医保支付中转页
const TransitPage = resolve => require.ensure([], () => resolve(require('@/views/transitPage')), 'PayResult');
const RegistrationRecordList = resolve => require.ensure([], () => resolve(require('@/views/RegistrationRecord/RegistrationRecordList.vue')), 'RegistrationRecordList');
const RegistrationRecordDetail = resolve => require.ensure([], () => resolve(require('@/views/RegistrationRecord/RegistrationRecordDetail.vue')), 'RegistrationRecordDetail');
//----------------------------自助开单
const ProjectChoice = resolve => require.ensure([], () => resolve(require('@/views/SelfOrder/ProjectChoice.vue')), 'ProjectChoice');
const OrderList = resolve => require.ensure([], () => resolve(require('@/views/SelfOrder/OrderList.vue')), 'OrderList');
const PayPreview = resolve => require.ensure([], () => resolve(require('@/views/SelfOrder/PayPreview.vue')), 'PayPreview');
const Payment = resolve => require.ensure([], () => resolve(require('@/views/SelfOrder/Payment.vue')), 'Payment');
const SelfOrderHistory = resolve => require.ensure([], () => resolve(require('@/views/SelfOrder/OrderHistory.vue')), 'SelfOrderHistory');
const SelfOrderHistoryDetail = resolve => require.ensure([], () => resolve(require('@/views/SelfOrder/OrderHistoryDetail.vue')), 'OrderHistoryDetail');
const OrderPayResult = resolve => require.ensure([], () => resolve(require('@/views/SelfOrder/OrderPayResult.vue')), 'OrderPayResult');

//智能客服
const CustomerService = resolve => require.ensure([], () => resolve(require('@/views/customerService')), 'CustomerService');
//候诊查询
const WaitingForConsultation = resolve => require.ensure([], () => resolve(require('@/views/WaitingForConsultation')), 'WaitingForConsultation');
const QuestionnaireSurveyDetail = resolve => require.ensure([], () => resolve(require('@/views/QuestionnaireSurvey/detail')), 'QuestionnaireSurveyDetail');
const QuestionnaireSurveyList = resolve => require.ensure([], () => resolve(require('@/views/QuestionnaireSurvey/list')), 'QuestionnaireSurveyList');
const QuestionnaireSurveyHistory = resolve => require.ensure([], () => resolve(require('@/views/QuestionnaireSurvey/history')), 'QuestionnaireSurveyHistory');
const BuildingDistribution = resolve => require.ensure([], () => resolve(require('@/views/buildingDistribution')), 'BuildingDistribution');
//出院带药
const IhRecordList = resolve => require.ensure([], () => resolve(require('@/views/OhTakeDrugs/IhRecordList.vue')), 'IhRecordList');
const OhTakeDrugsInfo = resolve => require.ensure([], () => resolve(require('@/views/OhTakeDrugs/OhTakeDrugsInfo.vue')), 'OhTakeDrugsInfo');
//自助购药
const SelfMedicine = resolve => require.ensure([], () => resolve(require('@/views/SelfMedicine')), 'SelfMedicine');
const DrugPayPreview = resolve => require.ensure([], () => resolve(require('@/views/SelfMedicine/DrugPayPreview.vue')), 'DrugPayPreview');
const DrugPayment = resolve => require.ensure([], () => resolve(require('@/views/SelfMedicine/DrugPayment.vue')), 'DrugPayment');
const DrugOrderPayResult = resolve => require.ensure([], () => resolve(require('@/views/SelfMedicine/DrugOrderPayResult.vue')), 'DrugOrderPayResult');
const DrugOrderHistory = resolve => require.ensure([], () => resolve(require('@/views/SelfMedicine/DrugOrderHistory.vue')), 'DrugOrderHistory');
const DrugOrderHistoryDetail = resolve => require.ensure([], () => resolve(require('@/views/SelfMedicine/DrugOrderHistoryDetail.vue')), 'DrugOrderHistoryDetail');
//检验检查预约——————————start
const TestInspectPage = resolve => require.ensure([], () => resolve(require('@/views/appointment/TestInspect/TestInspectPage.vue')), 'TestInspectPage');
const TestInspectList = resolve => require.ensure([], () => resolve(require('@/views/appointment/TestInspect/TestInspectList.vue')), 'TestInspectList');
const AppointmentProgramme = resolve => require.ensure([], () => resolve(require('@/views/appointment/TestInspect/AppointmentProgramme.vue')), 'AppointmentProgramme');
const TestInspectRecord = resolve => require.ensure([], () => resolve(require('@/views/appointment/TestInspect/TestInspectRecord.vue')), 'TestInspectRecord');
const TestInspectDetail = resolve => require.ensure([], () => resolve(require('@/views/appointment/TestInspect/TestInspectDetail.vue')), 'TestInspectDetail');

//人脸核身校验页
const FaceCheckView = resolve => require.ensure([], () => resolve(require('@/views/account/health-card/FaceCheckView.vue')), 'FaceCheckView');



//检验检查预约——————————end
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_PATH,
    // base: '/dist/',
    routes: [
        { // 默认页面
            path: '/',
            redirect: '/home/homeneirong'
        },
        { // 主路由
            path: '',
            name: 'Main',
            component: Main,
            children: [
                { // 首页
                    path: '/home',
                    component: Blank,
                    children: [
                        { // 就诊导航
                            path: 'homeneirong',
                            name: 'HomeNeirong',
                            component: Homepage
                        },
                        { // 医保APP入口页面
                            path: 'healthCare',
                            name: 'HealthCare',
                            component: Homepage
                        },
                        { // 新版主页
                            path: 'homepage',
                            name: 'Homepage',
                            component: Homepage
                        }
                    ]
                },
                { // 我的
                    path: '/account',
                    component: Blank,
                    children: [
                        {
                            path: '',
                            name: 'Account',
                            component: Account
                        }
                    ]
                },
                {//医院信息
                    path: '/hospitalInformation',
                    component: Blank,
                    children: [
                        {
                            path: '/',
                            name: 'HospitalInformation',
                            component: HospitalInformation
                        }
                    ],
                },
                { // 我的挂号记录
                    path: '/account',
                    component: Blank,
                    children: [
                        {
                            path: 'register',
                            name: 'Register',
                            component: Register
                        },
                    ]
                },
                {
                    path: '/healthCardList',
                    name: 'HealthCardList',
                    component: HealthCardList
                },
                {//科室导航
                    path: '/departmentList',
                    name: 'DepartmentList',
                    component: DepartmentList,
                }
            ]
        },
        {//医生信息
            path: '/doctorProfile',
            name: 'DoctorProfile',
            component: DoctorProfile,
        },
        {//科室首页
            path: '/departmentIndex',
            name: 'DepartmentIndex',
            component: DepartmentIndex,
        },
        {
            path: '/testInspect',
            name: '',
            component: Blank,
            children: [
                {
                    path: 'testInspectPage',
                    name: 'TestInspectPage',
                    component: TestInspectPage
                },
                {
                    path: 'testInspectList',
                    name: 'TestInspectList',
                    component: TestInspectList
                },
                {
                    path: 'appointmentProgramme',
                    name: 'AppointmentProgramme',
                    component: AppointmentProgramme
                },
                {
                    path: 'testInspectRecord',
                    name: 'TestInspectRecord',
                    component: TestInspectRecord
                },
                {
                    path: 'testInspectDetail',
                    name: 'TestInspectDetail',
                    component: TestInspectDetail
                }
            ]
        },
        {
            path: '/testInspect',
            name: '',
            component: Blank,
            children: [
                {
                    path: 'testInspectPage',
                    name: 'TestInspectPage',
                    component: TestInspectPage
                },
                {
                    path: 'testInspectList',
                    name: 'TestInspectList',
                    component: TestInspectList
                },
                {
                    path: 'appointmentProgramme',
                    name: 'AppointmentProgramme',
                    component: AppointmentProgramme
                },
                {
                    path: 'testInspectRecord',
                    name: 'TestInspectRecord',
                    component: TestInspectRecord
                },
                {
                    path: 'testInspectDetail',
                    name: 'TestInspectDetail',
                    component: TestInspectDetail
                }
            ]
        },
        //自助购药
        {
            path: '/selfDrug',
            name: 'SelfDrugBlank',
            component: Blank,
            children: [
                {//自助购药
                    path: 'drugList',
                    name: 'SelfMedicine',
                    component: SelfMedicine,
                },
                {//自助购药支付预览
                    path: 'payPreview',
                    name: 'DrugPayPreview',
                    component: DrugPayPreview,
                },
                {//自助购药支付页面
                    path: 'payment',
                    name: 'DrugPayment',
                    component: DrugPayment,
                },
                {//自助购药支付结果页面
                    path: 'orderPayResult',
                    name: 'DrugOrderPayResult',
                    component: DrugOrderPayResult,
                },
                {//自助购药订单记录页面
                    path: 'drugOrderHistory',
                    name: 'DrugOrderHistory',
                    component: DrugOrderHistory,
                },
                {//自助购药订单记录详情页面
                    path: 'drugOrderHistoryDetail',
                    name: 'DrugOrderHistoryDetail',
                    component: DrugOrderHistoryDetail,
                }
            ]
        },
        { // 自助开单
            path: '/selfOrder',
            component: Blank,
            children: [
                {//项目选择
                    path: 'projectChoice',
                    name: 'ProjectChoice',
                    component: ProjectChoice
                },
                {//订单列表
                    path: 'orderList',
                    name: 'OrderList',
                    component: OrderList
                },
                {//支付前预览
                    path: 'payPreview',
                    name: 'PayPreview',
                    component: PayPreview
                },
                {//支付页
                    path: 'payment',
                    name: 'Payment',
                    component: Payment
                },
                {//记录页
                    path: 'history',
                    name: 'SelfOrderHistory',
                    component: SelfOrderHistory
                },
                {//记录页
                    path: 'historyDetail',
                    name: 'OrderHistoryDetail',
                    component: SelfOrderHistoryDetail
                },
                {//支付成功
                    path: 'orderPayResult',
                    name: 'OrderPayResult',
                    component: OrderPayResult
                }
            ]
        },
        {
            path: '/payResult',
            name: 'PayResult',
            component: PayResult
        },
        {
            path: '/evaluation',
            name: 'Evaluation',
            component: Evaluation
        },
        {
            path: '/myEvaluation',
            name: 'MyEvaluation',
            component: MyEvaluation
        },
        {
            path: '/wxDoctorEvaluate',
            name: 'WxDoctorEvaluate',
            component: WxDoctorEvaluate
        },
        {
            //二维码扫描付款
            path: '/QRcode',
            name: 'QRcode',
            component: QRcode,
        },
        { // 未关注
            path: '/not',
            name: 'Not',
            component: Not,
            meta: {
                requireAuth: true, // 判断是否需要登录
            },
        },
        { // 处方签
            path: '/prescription',
            name: 'Prescription',
            component: Prescription,
            meta: {
                requireAuth: true, // 判断是否需要登录
            },
        },
        {//健康卡
            path: '/healthCardList',
            name: 'HealthCardListBlank',
            component: Blank,
            children: [
                {
                    path: '/cardInformation',
                    name: 'CardInformation',
                    component: CardInformation
                },
                {
                    path: '/faceRecognition',
                    name: 'FaceRecognition',
                    component: FaceRecognition
                }, {
                    path: '/CardDetail',
                    name: 'CardDetail',
                    component: CardDetail
                }, {
                    path: '/relationship',
                    name: 'Relationship',
                    component: Relationship
                },
                {
                    path: '/faceCheckView',
                    name: 'FaceCheckView',
                    component: FaceCheckView
                },
            ]
        },
        {//核酸检测预约须知
            path: '/booking',
            name: 'Booking',
            component: Booking,
        },
        {//检测核酸检测问诊表是否填写
            path: '/interrogationfinish',
            name: 'Interrogationfinish',
            component: Interrogationfinish,
        },
        {//核酸检测
            path: '/nat',
            name: 'Nat',
            component: Nat,
        },
        {//核酸检测流行病学史参考问诊
            path: '/interrogationtable',
            name: 'Interrogationtable',
            component: Interrogationtable,
        },
        {// 核酸预约记录
            path: '/natrecord',
            name: 'Natrecord',
            component: Natrecord,
        },
        {// 核酸预约记录详情
            path: '/natrecorddetails',
            name: 'NatrecordDetails',
            component: NatrecordDetails,
        },
        {// 帮助中心
            path: '/helpCenter',
            name: 'HelpCenter',
            component: HelpCenter,
        },
        {// 报告查询
            path: '/report',
            name: 'Report',
            component: Report,
        },
        {// 检验报告
            path: '/checkout',
            name: 'Checkout',
            component: Checkout
        },
        {// 检查报告
            path: '/inspect',
            name: 'Inspect',
            component: Inspect
        },
        {// 健康宣教
            path: '/healthEducation',
            name: 'HealthEducation',
            component: HealthEducation
        },
        {// 健康宣教文章列表
            path: '/articleList',
            name: 'ArticleList',
            component: ArticleList
        },
        {// 慢病栏目详情页
            path: '/articleDetail',
            name: 'ArticleDetail',
            component: ArticleDetail
        },

        {// 心理栏目
            path: '/psychology',
            name: 'Psychology',
            component: Psychology
        },
        {// 心理栏目详情页
            path: '/psychologycontent',
            name: 'Psychologycontent',
            component: Psychologycontent
        },
        {// 就医栏目
            path: '/hospitalize',
            name: 'Hospitalize',
            component: Hospitalize
        },
        {// 就医栏目详情页
            path: '/hospitalizeContent',
            name: 'HospitalizeContent',
            component: Hospitalizecontent
        },
        {// 院内导航
            path: '/hospitalNavigation',
            name: 'hospitalNavigation',
            component: Hospitalnavigation
        },
        {//预约挂号
            path: '/appointmentDepartmentList',
            name: 'AppointmentDepartmentList',
            component: AppointmentDepartmentList
        },
        {
            path: '/confirmationAppointment',
            name: 'ConfirmationAppointment',
            component: ConfirmationAppointment
        },
        {
            path: '/scanToPay',
            name: 'ScanToPay',
            component: ScanToPay
        },
        {
            path: '/customerService',
            name: 'CustomerService',
            component: CustomerService
        },
        {//楼群分布
            path: '/buildingDistribution',
            component: BuildingDistribution,
            name: 'BuildingDistribution',
        },
        {
            path: '/waitingForConsultation',
            name: 'WaitingForConsultation',
            component: WaitingForConsultation
        },
        {//预约挂号
            path: '/appointmentDepartmentList',
            name: 'AppointmentDepartmentListBlank',
            component: Blank,
            children: [
                {
                    path: 'numSourceList',
                    name: 'NumSourceList',
                    component: NumSourceList
                },
                {
                    path: 'doctorTimePeriodNumSource',
                    name: 'DoctorTimePeriodNumSource',
                    component: DoctorTimePeriodNumSource
                },
                {
                    path: 'success',
                    name: 'Success',
                    component: Success
                },
            ]
        },
        {//当日挂号
            path: '/todayDepartmentList',
            name: 'TodayDepartmentList',
            component: TodayDepartmentList
        },
        //智慧导诊
        {
            path: '/wisdomLeading',
            name: 'WisdomLeading',
            component: WisdomLeading
        },
        {//当日挂号
            path: '/todayDepartmentList',
            name: 'TodayDepartmentListBlank',
            component: Blank,
            children: [
                {
                    path: 'todayNumSourceList',
                    name: 'TodayNumSourceList',
                    component: TodayNumSourceList
                },
            ]
        },
        {//科室导航
            path: '/departmentIndex',
            name: 'DepartmentIndexBlank',
            component: Blank,
            children: [
                {
                    path: 'departmentNavigation',
                    name: 'DepartmentNavigation',
                    component: DepartmentNavigation
                },
                {
                    path: 'doctorsList',
                    name: 'DoctorsList',
                    component: DoctorsList,
                },
            ]
        },
        {//住院预缴费
            path: '/hospitalizationInput',
            name: 'HospitalizationInput',
            component: HospitalizationInput
        },
        {
            path: '/hospitalizationMoney',
            name: 'HospitalizationMoney',
            component: HospitalizationMoney
        },
        {//住院预缴费
            path: '/hospitalizationInput',
            name: 'HospitalizationPaymentBlank',
            component: Blank,
            children: [
                {
                    path: 'hospitalizationPayment',
                    name: 'HospitalizationPayment',
                    component: HospitalizationPayment
                },
                {
                    path: 'hospitalizationDetails',
                    name: 'HospitalizationDetails',
                    component: HospitalizationDetails
                },
                {
                    path: 'hospitalizationDailyListingList',
                    name: 'HospitalizationDailyListingList',
                    component: HospitalizationDailyListingList
                }
            ]
        },
        {//门诊医嘱缴费
            path: '/outpatientPrescription',
            name: 'OutpatientPrescription',
            component: OutpatientPrescription,

        },

        {//门诊医嘱缴费
            path: '/outpatientPrescription',
            component: Blank,
            children: [
                {
                    path: 'outpatientDetails',
                    name: 'OutpatientDetails',
                    component: OutpatientDetails
                },
                {
                    path: 'outpatientUnpaidDetails',
                    name: 'OutpatientUnpaidDetails',
                    component: OutpatientUnpaidDetails
                }

            ]
        },
        { // 我的挂号记录
            path: '/register',
            component: Blank,
            children: [
                {
                    path: 'registerContent',
                    name: 'RegisterContent',
                    component: RegisterContent
                },
            ]
        },
        {//就医指南
            path: '/medicalGuide',
            component: MedicalGuide,
            name: 'MedicalGuide',
        },
        {
            path: '/medicalGuide',
            component: Blank,
            children: [
                {
                    path: 'medicalGuideContent',
                    name: 'MedicalGuideContent',
                    component: MedicalGuideContent
                },
            ]
        },
        {//消息中心
            path: '/messageCenter',
            component: MessageCenter,
            name: 'MessageCenter',
        },
        {
            path: '/MessageCenter',
            component: Blank,
            children: [
                {
                    path: 'messageDetail',
                    name: 'MessageDetail',
                    component: MessageDetail
                },
            ]
        },
        {//问卷调查
            path: '/questionnaireSurvey',
            component: Blank,
            children: [
                {
                    path: 'list',
                    name: 'QuestionnaireSurveyList',
                    component: QuestionnaireSurveyList
                },
                {
                    path: 'detail',
                    name: 'QuestionnaireSurveyDetail',
                    component: QuestionnaireSurveyDetail
                },
                {
                    path: 'history',
                    name: 'QuestionnaireSurveyHistory',
                    component: QuestionnaireSurveyHistory
                }
            ]
        },
        {//中药
            path: '/zyNotice',
            name: 'zyNotice',
            component: zyNotice,
        },
        {//中药
            path: '/medicinebuy',
            name: 'MedicineBuy',
            component: MedicineBuy,
        },
        {//中药
            path: '/onlinePrescription',
            name: 'OnlinePrescription',
            component: OnlinePrescription,
        },
        {//中药
            path: '/onlinePrescriptionDetails',
            name: 'OnlinePrescriptionDetails',
            component: OnlinePrescriptionDetails,
        },
        {//中药
            path: '/onlinePrescriptionDetails_wzf',
            name: 'OnlinePrescriptionDetails_wzf',
            component: OnlinePrescriptionDetails_wzf,
        },
        {
            path: '/illnessInfo',
            name: 'IllnessInfo',
            component: () => import('@/views/illness-info/index.vue'),
        },
        {
            path: '/myPatient',
            name: 'MyPatient',
            component: () => import('@/views/my-patient/index.vue'),
        },
        {
            path: '/createMyPatient',
            name: 'CreateMyPatient',
            component: () => import('@/views/my-patient/create-my-patient/index.vue'),
        },
        {
            path: '/inquiryRecord',
            name: 'InquiryRecord',
            component: () => import('@/views/inquiry-record/index.vue'),
        },
        {
            path: '/notification',
            name: 'Notification',
            component: () => import('@/views/notification/index.vue'),
        },
        {
            path: '/transitPage',
            name: 'TransitPage',
            component: TransitPage
        },
        {
            path: '/registrationRecordList',
            name: 'RegistrationRecordList',
            component: RegistrationRecordList
        },
        {
            path: '/registrationRecordDetail',
            name: 'RegistrationRecordDetail',
            component: RegistrationRecordDetail
        },
        {//出院带药
            path: '/ohTakeDrug',
            component: Blank,
            children: [
                {
                    path: 'ihRecordList',
                    name: 'IhRecordList',
                    component: IhRecordList
                },
                {
                    path: 'info',
                    name: 'OhTakeDrugsInfo',
                    component: OhTakeDrugsInfo
                }
            ]
        },
        { // 兜底：路径异常时回首页，避免 router-view 渲染空白
            path: '*',
            redirect: '/home/homepage'
        }
    ]
})
// router.beforeEach((to, from, next) => {
//     console.log('to', JSON.stringify(to))
//     console.log('from', JSON.stringify(from))
//     if (from.path === '/') {
//         if (to.path.indexOf('/home/homeNeirong') > -1) {
//             next()
//         } else {
//             next()
//         }
//     } else
//         next()
// })
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js